export const cleanAdvisorSnippet = {
    label: 'New Advisor Snippet',
    config: {
        produceChiefComplaint: false,
        showChiefComplaints: true,
        onlyChiefComplaints: false,
    },
};
export const SnippetConfig_LabelMap = {
    produceChiefComplaint: 'Produce Chief Complaints',
    showChiefComplaints: 'Show Chief Complaints',
    onlyChiefComplaints: 'Show Only Chief Complaints'
};
export const SnippetConfig_InfoMap = {
    produceChiefComplaint: 'Are the results of this snippet chief complaints',
    showChiefComplaints: 'Should this snippet show chief complaints',
    onlyChiefComplaints: 'Should this snippet show ONLY chief complaints',
};
//# sourceMappingURL=consts.js.map